import React, { useState } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

const apiUrl = process.env.REACT_APP_API_URL;
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

function Quickcontact() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [course, setCourse] = useState("");
  const [track, setTrack] = useState("");
  const [description, setDescription] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    if (recaptchaSiteKey && !captchaToken) {
      setError("Please complete the captcha before submitting.");
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/api/contact`, {
        name,
        phone,
        email,
        course,
        track,
        description,
        captchaToken,
      });
      if (response.data.success) {
        setSuccess("Your message has been sent successfully!");
        // Reset form
        setName("");
        setPhone("");
        setEmail("");
        setCourse("");
        setTrack("");
        setDescription("");
        setCaptchaToken("");
      } else {
        setError(response.data.message || "Failed to send message.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error sending message.");
    }
  };

  return (
    <>
      {/* Strat Contact */}
      <div className="ak-height-125 ak-height-lg-80" />
      <div className="container-fluid px-md-0">
        <div className="contact-form-content">
          <div className="contact-form-img image-hov-one">
            <img src="assets/img/contact/contact-img.png" alt="..." />
          </div>
          <div className="contact-form">
            <div>
              <h5 className="contact-title">
                Ready to elevate your career in Facilities &amp; Professional
                Management? Our expert team is here to guide you with global
                certifications, practical training, and personalized support.
                Fill out the form below and let’s start your journey.
              </h5>
              <div className="ak-height-40 ak-height-lg-30" />
            </div>
            {success && <div className="alert alert-success mb-16">{success}</div>}
            {error && <div className="alert alert-danger mb-16">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-inputs">
                <div className="type_1">
                  <label htmlFor="fullname" className="form-label">
                    Your Name
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="fullname"
                    className="csame"
                    placeholder="Write your name here..."
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="form-inputs">
                <div className="type_1">
                  <label htmlFor="YourPhone" className="form-label">
                    Your Phone
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    id="YourPhone"
                    className="csame"
                    placeholder="Write your phone number here..."
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                <div className="type_1">
                  <label htmlFor="emailInput" className="form-label">
                    Your Email*
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="emailInput"
                    className="csame"
                    placeholder="Write your email here..."
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="form-inputs">
                <div className="type_1">
                  <label htmlFor="websiteInput" className="form-label">
                    Course
                  </label>
                  <select
                    name="website"
                    id="websiteInput"
                    className="csame"
                    value={course}
                    onChange={(e) => setCourse(e.target.value)}
                    required
                  >
                    <option
                      value=""
                      disabled
                      selected
                      hidden
                      className="select-placeholder"
                    >
                      Which Course you are interested in...
                    </option>
                    <option value="Core Facilities Management Courses">Core Facilities Management Courses</option>
                    <option value="Artificial Intelligence Courses">Artificial Intelligence Courses</option>
                    <option value="Professional Courses">Professional Courses</option>
                    <option value="Quality & Prpcess Management">Quality & Prpcess Management</option>
                    <option value="Soft Skills & Language Training">Soft Skills & Language Training</option>
                  </select>
                </div>
                <div className="type_1">
                  <label htmlFor="budgetInput" className="form-label">
                    Track
                  </label>
                  <select
                    name="budget"
                    id="budgetInput"
                    className="csame"
                    value={track}
                    onChange={(e) => setTrack(e.target.value)}
                    required
                  >
                    <option
                      value=""
                      disabled
                      selected
                      hidden
                      className="select-placeholder"
                    >
                      What is your time plan...
                    </option>
                    <option value="Crash Course">Crash Course</option>
                    <option value="Full Time">Full Time</option>
                  </select>
                </div>
              </div>
              <div className="form-textarea">
                <div className="type_1">
                  <label htmlFor="textareaInput" className="form-label">
                    Description
                  </label>
                  <textarea
                    name="description"
                    rows={3}
                    id="textareaInput"
                    className="csame"
                    placeholder="Write description details..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
              {recaptchaSiteKey && (
                <>
                  <div className="ak-height-20 ak-height-lg-15" />
                  <ReCAPTCHA sitekey={recaptchaSiteKey} onChange={(token) => setCaptchaToken(token || "")} />
                </>
              )}
              <div className="ak-height-40 ak-height-lg-30" />
              <button type="submit" className="common-btn border-0">
                <span>Send Message</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_201_978fsdf)">
                      <path
                        d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
                        stroke="#030917"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_201_978fsdf">
                        <rect
                          width={14}
                          height={14}
                          fill="white"
                          transform="translate(0.00927734)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* End Contact */}
    </>
  );
}

export default Quickcontact;